import { Box, Button, Divider, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import CreatePlanForm, { ICreatePlanForm } from "../partials/form";

import CreatePlanStyle from "./style";

import { useCreatePlan } from "@/api/hooks/usePlans";
import { AvailableCurrency } from "@/api/types";
import { useCheckPermissionAccess } from "@/hooks/useCheckPermissionAccess";
import ROUTE_CONSTANTS from "@/constants/route-constants";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

OperationAccess.CREATE;
export default function CreatePlan() {
    const { mutate: createPlan } = useCreatePlan();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const createAccess = useCheckPermissionAccess(PagesAccess.PLANS, OperationAccess.CREATE);

    const handleSubmit = (formData: ICreatePlanForm) => {
        const {
            en_title,
            ar_title,
            en_name,
            ar_name,
            en_subtitle,
            ar_subtitle,
            en_description,
            ar_description,
            en_trialTitle,
            ar_trialTitle,
            en_trialSubtitle,
            ar_trialSubtitle,
            features,
            ...rest
        } = formData;

        if (createAccess) {
            createPlan(
                {
                    params: { currency: formData.currency as AvailableCurrency },
                    body: {
                        ml_title: { en: en_title, ar: ar_title },
                        ml_name: { en: en_name, ar: ar_name },
                        ml_subtitle: { en: en_subtitle, ar: ar_subtitle },
                        ml_description: { en: en_description ?? "", ar: ar_description ?? "" },
                        ml_trialTitle:
                            en_trialTitle || ar_trialTitle
                                ? { en: en_trialTitle ?? "", ar: ar_trialTitle ?? "" }
                                : undefined,
                        ml_trialSubtitle:
                            en_trialSubtitle || ar_trialSubtitle
                                ? { en: en_trialSubtitle ?? "", ar: ar_trialSubtitle ?? "" }
                                : undefined,
                        ml_features: features,
                        ...rest,
                    },
                },
                {
                    onSuccess: () => {
                        navigate(-1);
                    },
                }
            );
        } else {
            enqueueSnackbar("You don't have the correct rights to Create a new plan.", { variant: "warning" });
        }
    };

    return (
        <CreatePlanStyle>
            <Box className="plans-header">
                <Typography className="main-title">Create Plans</Typography>
                <Button component={Link} to={ROUTE_CONSTANTS.SETTINGS.PLANS.ROOT.ABSOLUTE}>
                    Back To Plan List
                </Button>
            </Box>
            <Divider />
            <Box className="form">
                <CreatePlanForm onSubmit={handleSubmit} />
            </Box>
        </CreatePlanStyle>
    );
}
